// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let NewQuestionEditor
require("./styles/admin.css")

export default NewQuestionEditor = (function () {
  NewQuestionEditor = class NewQuestionEditor extends (
    require("lib/static-shim").default(
      require("assessments/admin/views/question-editor").default
    )
  ) {
    static initClass() {
      this.prototype.template = require("assessments/admin/views/templates/new-question.html")

      this.prototype.events = {
        "change select": "setQuestionType",
        "click button": "addQuestion"
      }
    }

    setQuestionType(e) {
      const type = $(e.currentTarget).val()
      return this.model.set("assessment_question_type", type, { silent: true })
    }

    addQuestion(e) {
      e.preventDefault()
      this.trigger("state-change", "edit")
      this.model.set("skipValidation", false)
      return this
    }
  }
  NewQuestionEditor.initClass()
  return NewQuestionEditor
})()
